var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChiefExecutiveOfficer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "53px",
    viewBox: "0 0 60 53",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Chief Strategy Officer _ Chief Executive Officer")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chief-Strategy-Officer-_-Chief-Executive-Officer",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59,34 L1,34 C0.44771525,34 0,33.5522847 0,33 L0,1 C0,0.44771525 0.44771525,0 1,0 L59,0 C59.5522847,0 60,0.44771525 60,1 L60,33 C60,33.5522847 59.5522847,34 59,34 Z M2,32 L58,32 L58,2 L2,2 L2,32 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,10 L39,10 L39,12 L41.945,12 L30.1,20.687 L22.706,13.293 C22.3155001,12.9026181 21.6824999,12.9026181 21.292,13.293 L8.292,26.293 L9.706,27.707 L22,15.414 L29.293,22.707 C29.6420448,23.057085 30.1945192,23.099583 30.593,22.807 L44,12.974 L44,16 L46,16 L46,11 C46,10.4477153 45.5522847,10 45,10 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "49 5 52 8 55 5 55 11 49 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,13 C6.34314575,13 5,14.3431458 5,16 C5,17.6568542 6.34314575,19 8,19 C9.65685425,19 11,17.6568542 11,16 C11,14.3431458 9.65685425,13 8,13 Z M8,17 C7.44771525,17 7,16.5522847 7,16 C7,15.4477153 7.44771525,15 8,15 C8.55228475,15 9,15.4477153 9,16 C9,16.5522847 8.55228475,17 8,17 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,8 C22,6.34314575 20.6568542,5 19,5 C17.3431458,5 16,6.34314575 16,8 C16,9.65685425 17.3431458,11 19,11 C20.6568542,11 22,9.65685425 22,8 Z M19,9 C18.4477153,9 18,8.55228475 18,8 C18,7.44771525 18.4477153,7 19,7 C19.5522847,7 20,7.44771525 20,8 C20,8.55228475 19.5522847,9 19,9 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "32.707 7.707 31.293 6.293 30 7.586 28.707 6.293 27.293 7.707 28.586 9 27.293 10.293 28.707 11.707 30 10.414 31.293 11.707 32.707 10.293 31.414 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "23.293 22.293 22 23.586 20.707 22.293 19.293 23.707 20.586 25 19.293 26.293 20.707 27.707 22 26.414 23.293 27.707 24.707 26.293 23.414 25 24.707 23.707"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 39,
    cy: 24,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,39 L35,51 C35,52.1045695 35.8954305,53 37,53 C38.1045695,53 39,52.1045695 39,51 C39,52.1045695 39.8954305,53 41,53 C42.1045695,53 43,52.1045695 43,51 L43,39 L35,39 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,19 C43.8954305,19 43,19.8954305 43,21 L43,27 L31,27 L31,35 L35,35 L35,37 L43,37 L43,33 L47,33 L47,21 C47,19.8954305 46.1045695,19 45,19 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 35,
    y: 27,
    width: 8,
    height: 9
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChiefExecutiveOfficer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chief-executive-officer.f3c1e8e3.svg";
export { ForwardRef as ReactComponent };